var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 100 100",
    width: 24,
    height: 24,
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil0 {fill:#116EC1}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M87.7 68.48l0 -20.11c0,0 -0.83,-4.26 -5.22,-4.26l-3.38 0 0 -14.24c0,-38.49 -58.2,-38.49 -58.2,0l0 14.24 -3.38 0c-4.39,0 -5.22,4.26 -5.22,4.26l0 20.11c0,40.69 75.4,40.69 75.4,0zm-37.7 -7.11l0 0c3.35,0 6.09,2.74 6.09,6.09l0 13.79 -12.18 0 0 -13.79c0,-3.35 2.74,-6.09 6.09,-6.09zm18.28 -17.26l-36.56 0 0 -14.24c0,-24.01 36.56,-24.01 36.56,0l0 14.24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOn);
export default __webpack_public_path__ + "static/media/lock-on.386e721540d19fba3cd8260f04f720b5.svg";
export { ForwardRef as ReactComponent };